import { render, staticRenderFns } from "./listParticipants.vue?vue&type=template&id=00843b80&"
import script from "./listParticipants.vue?vue&type=script&lang=js&"
export * from "./listParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports